import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {
    IconButton,
    Card,
    CardHeader,
    CardText,
    Divider,
    RaisedButton,
    FlatButton,
    Slider,
    Toggle,
    SelectField,
    TextField,
    RadioButton,
    RadioButtonGroup,
    MenuItem,
    IconMenu,
    Popover,
} from 'material-ui';
import SyncIcon from 'material-ui/svg-icons/notification/sync';
import styled from 'styled-components';
import ImageUploaderContainer from '../../../../dash/front/components/ImageUploaderContainer';
import { displayMap, skins } from '../StyledUI';
import update from 'immutability-helper';
import SplitImageTPL from './SplitImageTPL';
import { SketchPicker } from 'react-color';
import color from 'color';
import config from 'cfg';
import qs from 'query-string';
import IconFont from 'material-ui/svg-icons/content/font-download';
import IconClear from 'material-ui/svg-icons/content/clear';
import IconUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import IconDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import IconImages from 'material-ui/svg-icons/image/collections';
import IconDelete from 'material-ui/svg-icons/action/delete';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import humanize from 'humanize-string';
import { GRADIENT_DIRECTION } from '../../../../dash/api/lib/overlays/constants';
import { options as brandingOptions, defaultOptions as brandingDefaultOptions, brandings } from '../views/Branding';
import cx from 'classnames';
import { value } from 'rumble-charts/lib/helpers';

import ImgManipulationDialogue from './editor/ImageManipulationsDialogue';
import { options as SMTeamLogoOptions } from '../views/SMTeamLogo';
var TemplateConstants = require('./TemplateConstants.js');

var colorsSets = {
    stats: [
        'statTableBgColor',
        'statTableTextColor',
        'statTableLabelTextColor',
        'statTextColor',
        'statColorHome',
        'statColorNeutral',
        'statColorAway',
        'positiveColor',
        'negativeColor',
    ],
    wld: ['wdl.win', 'wdl.draw', 'wdl.loss', 'wdl.notPlayed'],
    relegation: [
        'qualRelColors.leagueWinner',
        'qualRelColors.championsleague',
        'qualRelColors.championsleaguequal',
        'qualRelColors.relegation',
        'qualRelColors.championship_playoff',
        'qualRelColors.relegationplayoff',
        'qualRelColors.uefaqualplayoff',
        'qualRelColors.uefacup',
        'qualRelColors.uefaqual',
        'qualRelColors.promotion',
        'qualRelColors.promotionplayoff',
        'qualRelColors.qualification_to_next_stage',
    ],
    pitch: ['pitch.background', 'pitch.lines', 'pitch.stripes', 'pitch.bottomBorder'],
    radar: [
        'radar.strokeColorHome',
        'radar.strokeColorAway',
        'radar.strokeColorOpponent',
        'radar.fillColorHome',
        'radar.fillColorAway',
        'radar.fillColorOpponent',
        'radar.polygonBorderColor',
        'radar.polygonBgColor',
        'radar.labelTextColor',
    ],
    f1: [
        'f1.primaryColor',
        'f1.primaryTextColor',
        'f1.headerBgColor',
        'f1.headerTextColor',
        'f1.tableBgColor',
        'f1.tableTextColor',
        'f1.tableSecondaryTextColor',
        'f1.primaryCellColor',
        'f1.secondaryCellColor',
        'f1.primaryCellTextColor',
        'f1.secondaryCellTextColor',
        'f1.inprogress',
        'f1.finished',
        'f1.notstarted',
        'f1.trackLineColor',
        'f1.trackMapDetails',
        'f1.trackDrsColor',
    ],
};

const ColorPreview = styled.div`
    width: 18px;
    height: 18px;
    margin-top: -30px;
    margin-left: 238px;
    border: 1px solid #aaa;
`;

const toRGBA = color => {
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
};

const IMAGE_URL = {
    GRADIENT: `${config.dash.api.host}/api/media/overlays/gradient.svg`,
    TEAM_GRADIENT: `${config.dash.api.host}/api/media/overlays/gradient.svg?isTeamColor=true`,
    BORDER: `${config.dash.api.host}/api/media/overlays/border.svg`,
    DEFAULT: `${config.assets}/assets/sm_cover.png`,
};

const IMAGE_DEFAULT_PARAMS = {
    GRADIENT: {
        fromColor: 'rgba(206,147,216,1)',
        toColor: 'rgba(129,212,250,1)',
        direction: GRADIENT_DIRECTION.HORIZONTAL,
        progression: 'linear',
        gradientAlign: 'left',
        gradientWidth: '100',
        gradientHeight: '100',
    },
    BORDER: {
        color: 'rgba(0,0,0,1)',
        offset: 16,
        width: 2,
    },
    TEAM_COLOR: {
        direction: GRADIENT_DIRECTION.HORIZONTAL,
        progression: 'linear',
    },
};

class AddLayerButton extends React.PureComponent {
    state = {
        showLayerSelect: false,
        layerSelectElement: null,
    };

    closeLayerPopover = () => {
        this.setState({ showLayerSelect: false });
    };

    openLayerPopover = event => {
        const { currentTarget } = event;
        this.setState({
            layerSelectElement: currentTarget,
            showLayerSelect: true,
        });
    };

    render() {
        const { showLayerSelect, layerSelectElement } = this.state;
        const { addLayer } = this.props;

        return (
            <div>
                <Popover open={showLayerSelect} onRequestClose={this.closeLayerPopover} anchorEl={layerSelectElement}>
                    <MenuItem
                        primaryText="Image"
                        onTouchTap={() => {
                            addLayer(IMAGE_URL.DEFAULT);
                            this.closeLayerPopover();
                        }}
                    />
                    <MenuItem
                        primaryText="Gradient"
                        onTouchTap={() => {
                            addLayer(IMAGE_URL.GRADIENT + '?' + qs.stringify(IMAGE_DEFAULT_PARAMS.GRADIENT));
                            this.closeLayerPopover();
                        }}
                    />
                    <MenuItem
                        primaryText="Border"
                        onTouchTap={() => {
                            addLayer(IMAGE_URL.BORDER + '?' + qs.stringify(IMAGE_DEFAULT_PARAMS.BORDER));
                            this.closeLayerPopover();
                        }}
                    />
                    <MenuItem
                        primaryText="Team color"
                        onTouchTap={() => {
                            addLayer(IMAGE_URL.TEAM_GRADIENT + '&' + qs.stringify(IMAGE_DEFAULT_PARAMS.TEAM_COLOR));
                            this.closeLayerPopover();
                        }}
                    />
                </Popover>
                <RaisedButton
                    style={{ width: '100%', marginTop: 16 }}
                    label="+Add"
                    onTouchTap={this.openLayerPopover}
                />
            </div>
        );
    }
}

AddLayerButton.propTypes = {
    addLayer: PropTypes.func.isRequired,
};

class FontEditPoporver extends React.Component {
    state = {
        value: {},
    };

    render = () => {
        const { font, anchorEl, open } = this.props;

        const fields = Object.keys(TemplateConstants.FONT);

        return (
            <Popover open={open} anchorEl={anchorEl} anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}>
                <div style={{ padding: 16 }}>
                    {fields.map(f => {
                        return (
                            <div key={f}>
                                <TextField
                                    defaultValue={font[f]}
                                    floatingLabelText={'$' + f}
                                    onBlur={e => {
                                        this.setState(
                                            update(this.state, {
                                                value: { $merge: { [f]: e.target.value } },
                                            }),
                                        );
                                    }}
                                />
                            </div>
                        );
                    })}

                    <div>
                        <FlatButton
                            label="Close"
                            onClick={() => {
                                if (this.props.onCloseRequest) this.props.onCloseRequest();
                            }}
                        />
                        <FlatButton
                            label="save"
                            onClick={() => {
                                const { value } = this.state;

                                if (this.props.onChange) this.props.onChange(value);
                            }}
                        />
                    </div>
                </div>
            </Popover>
        );
    };
}

class SplitImageTPLEditor extends React.Component {
    static propTypes = {
        onChange: PropTypes.func,
        theme: PropTypes.object,
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            imagePickerFor: null,
            customColors: {},
            smWdpWidgets: [],
        };
    }

    componentDidMount() {
        this.notifyChanges();
        this.interval = setInterval(this.handleCustomColorsEditing, 1000);
    }

    componentWillReceiveProps = nextProps => {
        if (nextProps.widgetId !== this.props.widgetId) {
            this.handleCustomColorsEditing('remove');
        }
    };

    componentWillUnmount() {
        this.handleCustomColorsEditing('remove');
        clearInterval(this.interval);
    }

    notifyChanges = theme => {
        this.props.onChange(theme);
    };

    handleCustomColorsEditing = remove => {
        if (!this.props.widgetId && !remove) return;
        const widgets = document.querySelectorAll('.sm-wdp');
        widgets.forEach(widget =>
            widget[remove ? 'removeEventListener' : 'addEventListener']('mousedown', this.customColorsMouseListener),
        );
    };

    customColorsMouseListener = e => {
        const isEditable = el => el.classList.value.indexOf('__c__') > -1;

        e.preventDefault();
        let el = e.target;

        let editable = isEditable(el);
        while (!editable && !Array.from(el.classList).includes('sm-wdp')) {
            el = el.parentElement;
            editable = isEditable(el);
        }
        if (editable) {
            const classes = Array.from(el.classList);
            const customClass = classes.find(c => c.indexOf('__c__') > -1);
            this.setState({
                showColorPickerForCustomClass: customClass,
            });
        } else {
            this.setState({
                showColorPickerForCustomClass: null,
            });
        }
    };

    addLayer = imageUrl => {
        const { theme } = this.props;
        this.notifyChanges(
            update(theme, {
                layers: {
                    $push: [
                        _.merge({
                            ...TemplateConstants.LAYER,
                            backgroundImage: imageUrl,
                        }),
                    ],
                },
            }),
        );
    };

    getGradientsPosition = () => {
        return this.props.theme.preview_overlay.gradient === 'radial'
            ? ['center']
            : [
                  'to bottom right',
                  'to bottom',
                  'to bottom left',
                  'to right',
                  'to left',
                  'to top right',
                  'to top',
                  'to top left',
              ];
    };

    renderMainColor = () => {
        return (
            <Card
                style={{ marginTop: '0' }}
                initiallyExpanded={localStorage.getItem('COLORS_EXP') === 'true'}
                onExpandChange={exp => {
                    localStorage.setItem('COLORS_EXP', exp);
                }}
            >
                <CardHeader
                    className="template-editor__header"
                    title="Main colors"
                    actAsExpander
                    showExpandableButton
                />
                <CardText expandable>
                    {this.renderColorField('primaryColor', 'Primary Color')}
                    {this.renderColorField('primaryTextColor', 'Primary Text Color')}

                    {this.renderColorField('content.backgroundColor', 'Background color')}
                    {this.renderColorField('content.accentColor', 'Accent color')}
                    {this.renderColorField('content.accentTextColor', 'Accent Text color')}

                    {this.renderColorField('content.accent2Color', 'Accent 2 color')}
                    {this.renderColorField('content.accent2TextColor', 'Accent Text 2 color')}

                    {this.renderColorField('substitutionOutColor', 'Substitution color')}
                    {this.renderColorField('brandingBackground', 'Branding background color')}
                </CardText>
            </Card>
        );
    };

    renderLayerControlMoreOption = (layer, index) => {
        var prevLayer = this.props.theme.layers[index - 1];
        var nextLayer = this.props.theme.layers[index + 1];
        var thisLayer = this.props.theme.layers[index];

        const { theme } = this.props;

        const handleDelete = () => {
            this.notifyChanges(
                update(theme, {
                    layers: {
                        $splice: [[index, 1]],
                    },
                }),
            );
        };

        const handeDown = () => {
            this.notifyChanges(
                update(theme, {
                    layers: {
                        $splice: [[index, 2, nextLayer, thisLayer]],
                    },
                }),
            );
        };

        const handleUp = () => {
            this.notifyChanges(
                update(theme, {
                    layers: {
                        $splice: [[index - 1, 2, thisLayer, prevLayer]],
                    },
                }),
            );
        };

        return (
            <IconMenu
                iconButtonElement={
                    <IconButton>
                        <MoreVertIcon />
                    </IconButton>
                }
            >
                <MenuItem primaryText="Autolayout" />
                <MenuItem leftIcon={<IconUp />} disabled={index === 0} primaryText="Move Up" onClick={handleUp} />
                <MenuItem
                    leftIcon={<IconDown />}
                    disabled={index === this.props.theme.layers.length - 1}
                    primaryText="Move Down"
                    onClick={handeDown}
                />

                <Divider />
                <MenuItem leftIcon={<IconDelete />} primaryText="Delete" onClick={handleDelete} />
            </IconMenu>
        );
    };

    properyChange = index => object => {
        const { theme } = this.props;
        const theme2 = update(theme, {
            layers: {
                [index]: { $merge: object },
            },
        });
        this.notifyChanges(theme2);
    };

    renderBorderLayerControl = (layer, index) => {
        const { backgroundImage } = layer;
        const expanded = this.props.layerDetailsExpanded === index;
        const queryValues = qs.parse(qs.extract(backgroundImage));
        const onChange = keyValObj => {
            const url = IMAGE_URL.BORDER + '?' + qs.stringify({ ...queryValues, ...keyValObj });
            this.properyChange(index)({ backgroundImage: url });
        };
        return (
            <div key={index} style={{ paddingBottom: 16 }}>
                <h3
                    style={{
                        backgroundColor: '#f4f4f4',
                        margin: '0 -16px',
                        padding: '12px 16px',
                        position: 'relative',
                    }}
                >
                    <span>{index + 1} Layer (border)</span>
                    <span style={{ position: 'absolute', right: 0, top: 0 }}>
                        {this.renderLayerControlMoreOption(layer, index)}
                    </span>
                </h3>
                <img src={backgroundImage} width="100%" style={{ marginTop: '16px' }} />
                <div>
                    <TextField
                        value={queryValues.color}
                        onFocus={() => this.invokeColorPicker(index)}
                        floatingLabelText="Border color"
                    />
                </div>
                {this.state.colorPickerFor !== index ? (
                    <ColorPreview style={{ backgroundColor: queryValues.color }} />
                ) : (
                    <div>
                        <div
                            style={{
                                position: 'fixed',
                                top: '0px',
                                right: '0px',
                                bottom: '0px',
                                left: '0px',
                            }}
                            onClick={() => {
                                this.setState({ colorPickerFor: false });
                            }}
                        />
                        <div style={{ position: 'absolute', zIndex: 2 }}>
                            <SketchPicker
                                key={'color' + index}
                                color={queryValues.color}
                                onChangeComplete={({ rgb: { r, g, b, a } }) =>
                                    onChange({
                                        color: `rgba(${r},${g},${b},${a})`,
                                    })
                                }
                            />
                        </div>
                    </div>
                )}
                <div className="customizer-label">Offset</div>
                <Slider
                    step={1}
                    min={1}
                    max={40}
                    key={index + '.border.offset'}
                    value={Number(queryValues.offset)}
                    sliderStyle={{
                        marginBottom: '0px',
                        marginTop: '12px',
                    }}
                    onChange={(e, value) => {
                        onChange({ offset: value });
                    }}
                />
                <div className="customizer-label">Width</div>
                <Slider
                    step={1}
                    min={1}
                    max={10}
                    key={index + '.border.widt'}
                    value={Number(queryValues.width)}
                    sliderStyle={{
                        marginBottom: '0px',
                        marginTop: '12px',
                    }}
                    onChange={(e, value) => {
                        onChange({ width: value });
                    }}
                />
                <RaisedButton
                    style={{ width: '100%' }}
                    label="Border manipulations"
                    onClick={e =>
                        this.setState({
                            layerDetailsExpanded: expanded ? null : index,
                        })
                    }
                />
                <br />
                <br />
                <Divider style={{ marginLeft: -16, marginRight: -16 }} inset />
                {this.renderImageManipulationsForLayer(index, layer, expanded)}
            </div>
        );
    };

    renderGradientLayerControl = (layer, index, el, isTeamColor) => {
        const { backgroundImage } = layer;
        const expanded = this.state.layerDetailsExpanded === index;
        const queryValues = qs.parse(qs.extract(backgroundImage));

        const onChange = keyValObj => {
            const url = IMAGE_URL.GRADIENT + '?' + qs.stringify({ ...queryValues, ...keyValObj });
            const { theme } = this.props;
            const theme2 = update(theme, {
                layers: {
                    [index]: { $merge: { backgroundImage: url } },
                },
            });

            this.notifyChanges(theme2);
        };
        return (
            <div key={index} style={{ paddingBottom: 16 }}>
                <h3
                    style={{
                        backgroundColor: '#f4f4f4',
                        margin: '0 -16px',
                        padding: '12px 16px',
                        position: 'relative',
                    }}
                >
                    <span>
                        {index + 1} Layer ({isTeamColor ? 'Team color' : 'Gradient'})
                    </span>
                    <span style={{ position: 'absolute', right: 0, top: 0 }}>
                        {this.renderLayerControlMoreOption(layer, index)}
                    </span>
                </h3>
                {!isTeamColor && <img src={backgroundImage} width="100%" style={{ marginTop: '16px' }} />}
                {!isTeamColor && (
                    <div>
                        <TextField
                            value={queryValues.fromColor}
                            onFocus={() => this.invokeColorPicker(index + '.fromColor')}
                            floatingLabelText="From color"
                        />
                    </div>
                )}
                {this.state.colorPickerFor !== index + '.fromColor' ? (
                    <ColorPreview style={{ backgroundColor: queryValues.fromColor }} />
                ) : (
                    <div>
                        <div
                            style={{
                                position: 'fixed',
                                top: '0px',
                                right: '0px',
                                bottom: '0px',
                                left: '0px',
                            }}
                            onClick={() => {
                                this.setState({ colorPickerFor: false });
                            }}
                        />
                        <div style={{ position: 'absolute', zIndex: 2 }}>
                            <SketchPicker
                                key={index + '.fromColor'}
                                color={queryValues.fromColor}
                                onChangeComplete={({ rgb: { r, g, b, a } }) =>
                                    onChange({
                                        fromColor: `rgba(${r},${g},${b},${a})`,
                                    })
                                }
                            />
                        </div>
                    </div>
                )}

                {!isTeamColor && (
                    <div>
                        <TextField
                            value={queryValues.fromColor}
                            onFocus={() => this.invokeColorPicker(index + '.toColor')}
                            floatingLabelText="To color"
                        />
                    </div>
                )}
                {this.state.colorPickerFor !== index + '.toColor' ? (
                    <ColorPreview style={{ backgroundColor: queryValues.toColor }} />
                ) : (
                    <div>
                        <div
                            style={{
                                position: 'fixed',
                                top: '0px',
                                right: '0px',
                                bottom: '0px',
                                left: '0px',
                            }}
                            onClick={() => {
                                this.setState({ colorPickerFor: false });
                            }}
                        />
                        <div style={{ position: 'absolute', zIndex: 2 }}>
                            <SketchPicker
                                key={index + '.toColor'}
                                color={queryValues.toColor}
                                onChangeComplete={({ rgb: { r, g, b, a } }) =>
                                    onChange({
                                        toColor: `rgba(${r},${g},${b},${a})`,
                                    })
                                }
                            />
                        </div>
                    </div>
                )}

                {!isTeamColor && (
                    <SelectField
                        key="gradient-align"
                        floatingLabelText="Align"
                        floatingLabelFixed
                        defaultValue={this.props.theme.content.gradientAlign}
                        value={this.props.theme.content.gradientAlign}
                        onChange={(event, index, value) => {
                            this.notifyChanges(
                                update(this.props.theme, {
                                    content: {
                                        $merge: { gradientAlign: value },
                                    },
                                }),
                            );
                        }}
                    >
                        {[
                            { val: 'left', key: 'Left' },
                            { val: 'right', key: 'Right' },
                            { val: 'top', key: 'Top' },
                            { val: 'bottom', key: 'Bottom' },
                        ].map(k => {
                            return <MenuItem value={k.val} primaryText={k.key} key={k.key} />;
                        })}
                    </SelectField>
                )}
                {!isTeamColor && (
                    <div>
                        <TextField
                            name="theme.content.gradientWidth"
                            floatingLabelText="Width %"
                            defaultValue={this.props.theme.content.gradientWidth}
                            floatingLabelFixed
                            onChange={(e, val) => {
                                this.notifyChanges(
                                    update(this.props.theme, {
                                        content: { $merge: { gradientWidth: val } },
                                    }),
                                );
                            }}
                        />
                    </div>
                )}
                {!isTeamColor && (
                    <div>
                        <TextField
                            name="theme.content.gradientHeight"
                            floatingLabelText="Height %"
                            defaultValue={this.props.theme.content.gradientHeight}
                            floatingLabelFixed
                            onChange={(e, val) => {
                                this.notifyChanges(
                                    update(this.props.theme, {
                                        content: { $merge: { gradientHeight: val } },
                                    }),
                                );
                            }}
                        />
                    </div>
                )}

                {!isTeamColor && (
                    <SelectField
                        value={queryValues.progression}
                        onChange={(event, index, value) => {
                            if (value !== queryValues.progression) {
                                onChange({ progression: value });
                            }
                        }}
                        floatingLabelText="Progression"
                    >
                        <MenuItem value="linear" primaryText="Linear" />
                        <MenuItem value="radial" primaryText="Radial" />
                    </SelectField>
                )}

                {isTeamColor && (
                    <div style={{ height: 80, fontWeight: 700, marginTop: 24, display: 'flex', alignItems: 'center' }}>
                        Team color is added to widget dynamically. You can change its opacity
                    </div>
                )}

                {!isTeamColor && (
                    <IconButton
                        tooltip="Swap colors"
                        onTouchTap={() =>
                            onChange({
                                fromColor: queryValues.toColor,
                                toColor: queryValues.fromColor,
                            })
                        }
                    >
                        <SyncIcon />
                    </IconButton>
                )}

                {queryValues.progression === 'linear' &&
                    !isTeamColor && (
                        <SelectField
                            value={queryValues.direction}
                            onChange={(event, index, value) => {
                                if (value !== queryValues.direction) {
                                    onChange({ direction: value });
                                }
                            }}
                            floatingLabelText="Direction"
                        >
                            {Object.keys(GRADIENT_DIRECTION).map(directionKey => (
                                <MenuItem
                                    key={directionKey}
                                    value={String(GRADIENT_DIRECTION[directionKey])}
                                    primaryText={humanize(directionKey)}
                                />
                            ))}
                        </SelectField>
                    )}
                <RaisedButton
                    style={{ width: '100%' }}
                    label={isTeamColor ? 'Change opacity' : 'Gradient manipulations'}
                    onClick={e =>
                        this.setState({
                            layerDetailsExpanded: expanded ? null : index,
                            anchorEl: e.target,
                        })
                    }
                />
                <br />
                <br />
                <Divider style={{ marginLeft: -16, marginRight: -16 }} inset />

                {this.renderImageManipulationsForLayer(index, layer, expanded, isTeamColor)}
            </div>
        );
    };

    renderImageManipulationsForLayer = (index, layer, expanded, isTeamColor) => {
        return (
            <ImgManipulationDialogue
                layer={layer}
                expanded={expanded}
                anchorEl={this.state.anchorEl}
                isTeamColor={isTeamColor}
                onProperyChange={object => {
                    const { theme } = this.props;
                    const theme2 = update(theme, {
                        layers: {
                            [index]: { $merge: object },
                        },
                    });
                    this.notifyChanges(theme2);
                }}
                onDoneClick={() => {
                    this.setState({ layerDetailsExpanded: null });
                }}
            />
        );
    };

    renderLayerControlByUrl = (layer, index, el) => {
        const { backgroundImage } = layer;
        if (backgroundImage.indexOf(IMAGE_URL.BORDER) === 0) {
            return this.renderBorderLayerControl(layer, index, el);
        } else if (backgroundImage.indexOf(IMAGE_URL.GRADIENT) === 0) {
            return this.renderGradientLayerControl(layer, index, el, backgroundImage.indexOf('isTeamColor') > -1);
        }
        return this.renderLayerControl(layer, index, el);
    };

    renderLayerControl = (layer, index) => {
        const expanded = this.state.layerDetailsExpanded === index;

        return (
            <div key={index} style={{ paddingBottom: 16 }}>
                <h3
                    style={{
                        backgroundColor: '#eaeaea',
                        margin: '0 -16px',
                        padding: '12px 16px',
                        position: 'relative',
                    }}
                >
                    <span>{index + 1} Layer</span>
                    <span style={{ position: 'absolute', right: 0, top: 0 }}>
                        {this.renderLayerControlMoreOption(layer, index)}
                    </span>
                </h3>

                <img
                    src={layer.backgroundImage}
                    width="100%"
                    style={{ marginTop: '16px', maxHeight: 200, objectFit: 'contain' }}
                />

                {this.renderImagePickerField(`layers.[${index}].backgroundImage`)}

                <RaisedButton
                    style={{ width: '100%' }}
                    label="Image manipulations"
                    onClick={e =>
                        this.setState({
                            layerDetailsExpanded: expanded ? null : index,
                            anchorEl: e.target,
                        })
                    }
                />
                <br />
                <br />
                <Divider style={{ marginLeft: -16, marginRight: -16 }} inset />

                {this.renderImageManipulationsForLayer(index, layer, expanded)}
            </div>
        );
    };

    renderLayersControls = () => {
        const { theme } = this.props;
        const { layerSelectElement, showLayerSelect } = this.state;

        return (
            <Card
                style={{ marginTop: '0' }}
                initiallyExpanded={localStorage.getItem('LAYERS_EXP') === 'true'}
                onExpandChange={exp => {
                    localStorage.setItem('LAYERS_EXP', exp);
                }}
            >
                <CardHeader
                    className="template-editor__header"
                    title="Layers Image"
                    actAsExpander
                    showExpandableButton
                />
                <CardText expandable>
                    <div style={{ marginTop: -15 }}>{theme.layers.map(this.renderLayerControlByUrl)}</div>
                    {theme.layers.length === 0 && <p>No layers</p>}
                    <AddLayerButton addLayer={this.addLayer} />
                </CardText>
            </Card>
        );
    };

    renderLayoutStaff = () => {
        const { theme } = this.props;

        const getPadding = val => {
            const nums = val.match(/[0-9]+/g) || ['0'];

            if (!nums || nums.length > 4) return '0';

            return nums.join(' ');
        };

        return (
            <Card
                style={{ marginTop: '0' }}
                initiallyExpanded={localStorage.getItem('LAYOUT_EXP') === 'true'}
                onExpandChange={exp => {
                    localStorage.setItem('LAYOUT_EXP', exp);
                }}
            >
                <CardHeader className="template-editor__header" title="Layout" actAsExpander showExpandableButton />
                <CardText expandable>
                    <TextField
                        name="theme.contentPadding"
                        floatingLabelText="Content Padding"
                        defaultValue={theme.contentPadding}
                        floatingLabelFixed
                        style={{ width: '100%' }}
                        onChange={(e, val) => {
                            this.notifyChanges(
                                update(theme, {
                                    $merge: { contentPadding: parseInt(val, 10) },
                                }),
                            );
                        }}
                    />
                    <TextField
                        name="theme.content.margin"
                        floatingLabelText="Content Offset"
                        defaultValue={theme.content.margin}
                        floatingLabelFixed
                        style={{ width: '100%' }}
                        onChange={(e, val) => {
                            this.notifyChanges(
                                update(theme, {
                                    content: { $merge: { margin: getPadding(val) } },
                                }),
                            );
                        }}
                    />
                    <TextField
                        name="theme.content.margin"
                        floatingLabelText="Content Padding"
                        defaultValue={theme.content.padding}
                        floatingLabelFixed
                        style={{ width: '100%' }}
                        onChange={(e, val) => {
                            this.notifyChanges(
                                update(theme, {
                                    content: { $merge: { padding: getPadding(val) } },
                                }),
                            );
                        }}
                    />

                    {this.renderColorField('content.fillColor', 'Fill color')}

                    <TextField
                        name="theme.content.minHeight"
                        floatingLabelText="Min Height"
                        defaultValue={theme.content.minHeight}
                        floatingLabelFixed
                        style={{ width: '100%' }}
                        onChange={(e, val) => {
                            this.notifyChanges(
                                update(theme, {
                                    content: {
                                        $merge: { minHeight: parseInt(val, 10) },
                                    },
                                }),
                            );
                        }}
                    />
                    <SelectField
                        key="top"
                        floatingLabelText="Content align"
                        floatingLabelFixed
                        defaultValue={theme.content.valign}
                        value={theme.content.valign}
                        onChange={(event, index, value) => {
                            this.notifyChanges(
                                update(theme, {
                                    content: {
                                        $merge: { valign: value },
                                    },
                                }),
                            );
                        }}
                    >
                        {[
                            { val: 'top', key: 'Top' },
                            { val: 'center', key: 'Center' },
                            { val: 'flex-end', key: 'Bottom' },
                        ].map(k => {
                            return <MenuItem value={k.val} primaryText={k.key} key={k.key} />;
                        })}
                    </SelectField>
                </CardText>
            </Card>
        );
    };

    renderSkinSelect = () => {
        const { theme } = this.props;

        return (
            <SelectField
                floatingLabelText="Choose skin"
                value={theme.display.skin || null}
                key="skin"
                onChange={(e, index, skinId) => {
                    const toSet = {};
                    const skin = _.find(skins, s => s.id === skinId);
                    Object.keys(theme.display).forEach(elementName => {
                        toSet[elementName] = 'default';
                    });

                    Object.keys(skin.displayMap).forEach(elementName => {
                        toSet[elementName] = skin.displayMap[elementName];
                    });

                    this.notifyChanges(
                        update(theme, {
                            display: { $merge: toSet },
                        }),
                    );
                }}
            >
                {skins.map(({ name, id }) => {
                    return <MenuItem key={id} value={id} primaryText={name} />;
                })}
            </SelectField>
        );
    };

    renderDisplayStaff = () => {
        const { theme } = this.props;
        return (
            <Card
                style={{ marginTop: '0' }}
                initiallyExpanded={localStorage.getItem('STANDARD_COMP_EXP') === 'true'}
                onExpandChange={exp => {
                    localStorage.setItem('STANDARD_COMP_EXP', exp);
                }}
            >
                <CardHeader
                    className="template-editor__header"
                    title="Default elements"
                    actAsExpander
                    showExpandableButton
                />
                <CardText expandable>
                    <SelectField
                        key="top"
                        floatingLabelText={'Team Logo Variants ' + theme.teamLogo}
                        floatingLabelFixed
                        defaultValue={theme.teamLogo}
                        value={theme.teamLogo}
                        onChange={(event, index, value) => {
                            this.notifyChanges(
                                update(theme, {
                                    $merge: { teamLogo: value },
                                }),
                            );
                        }}
                    >
                        {SMTeamLogoOptions.map(i => <MenuItem value={i} primaryText={i} key={i} />)}
                    </SelectField>

                    {this.renderSkinSelect()}

                    {Object.keys(displayMap).map(elementName => {
                        const elementDisplayOptions = Object.keys(displayMap[elementName]);

                        return (
                            <SelectField
                                floatingLabelText={elementName}
                                value={theme.display[elementName]}
                                key={elementName}
                                onChange={(e, index, display) => {
                                    const toSet = { skin: null };
                                    toSet[elementName] = display;

                                    this.notifyChanges(
                                        update(theme, {
                                            display: { $merge: toSet },
                                        }),
                                    );
                                }}
                            >
                                {elementDisplayOptions.map(o => {
                                    return <MenuItem key={o} value={o} primaryText={o} />;
                                })}
                            </SelectField>
                        );
                    })}
                </CardText>
            </Card>
        );
    };

    isUsingParentValue = key => {
        if (!this.props.widgetId) return false;
        if (_.get(this.props.overriden, key)) {
            return false;
        }
        return true;
    };

    resetIfWidgetMode = key => {
        if (this.props.widgetId && !this.isUsingParentValue(`${key}`)) {
            return (
                <IconButton
                    iconStyle={{ width: 18, height: 18 }}
                    tooltip="Reset to theme"
                    onClick={() => this.deleteValueFromWidget(key)}
                >
                    <IconClear />
                </IconButton>
            );
        }
    };

    deleteValueFromWidget = key => {
        if (this.props.onWidgetResetProperty) this.props.onWidgetResetProperty(key);
    };

    renderFontStaff = () => {
        const { theme } = this.props;

        const backgroundColor = color(theme.content.backgroundColor)
            .alpha(1.0)
            .rgb()
            .toString();

        return (
            <Card
                initiallyExpanded={localStorage.getItem('FONTS_EXP') === 'true'}
                onExpandChange={exp => {
                    localStorage.setItem('FONTS_EXP', exp);
                }}
            >
                <CardHeader className="template-editor__header" title="Fonts" actAsExpander showExpandableButton />
                <CardText expandable>
                    {this.renderFontField('title', 'Title font', {
                        color: theme.titleColor,
                        backgroundColor,
                    })}
                    {this.renderColorField('titleColor', 'Title color')}
                    {this.renderColorField('subTitleColor', 'Sub title color')}

                    <div key="Title font size">
                        {this.renderFontSizeField('Title font size', 'fonts.title.fontSize')}
                        {this.renderFontSizeField('Sub Title font size', 'fonts.subTitle.fontSize')}
                    </div>
                    <br />
                    <div style={{ margin: '16px -16px' }}>
                        <Divider />
                    </div>

                    {this.renderFontField('main', 'Main font', {
                        color: theme.color,
                        backgroundColor,
                    })}
                    {this.renderColorField('color', 'Main font color')}
                </CardText>
            </Card>
        );
    };
    invokeColorPicker = key => {
        this.setState({ colorPickerFor: key });
    };

    renderColorPicker = (key, val, onChange) => {
        if (this.state.colorPickerFor !== key) return <ColorPreview style={{ backgroundColor: val }} />;
        return (
            <div>
                <div
                    key="ov"
                    style={{
                        position: 'fixed',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        left: '0px',
                    }}
                    onClick={() => {
                        this.setState({ colorPickerFor: false });
                    }}
                />
                <div style={{ position: 'absolute', zIndex: 2 }}>
                    <SketchPicker key="pi" color={val} onChangeComplete={onChange} />
                </div>
            </div>
        );
    };

    renderBrandingStaff = () => {
        const { theme } = this.props;
        const branding = theme.defaultBranding;
        const { brandingProps } = theme;
        return (
            <Card
                style={{ marginTop: '0px' }}
                initiallyExpanded={localStorage.getItem('BRAND_EXP') === 'true'}
                onExpandChange={exp => {
                    localStorage.setItem('BRAND_EXP', exp);
                }}
            >
                <CardHeader
                    className="template-editor__header"
                    title="Default branding"
                    actAsExpander
                    showExpandableButton
                />
                <CardText expandable>
                    <SelectField
                        floatingLabelText="Primary branding logos"
                        value={theme.defaultBranding.brandingPrimary}
                        defaultValue={theme.defaultBranding.brandingPrimary}
                        onChange={(e, index, value) => {
                            this.notifyChanges(
                                update(theme, {
                                    defaultBranding: {
                                        $merge: { brandingPrimary: value },
                                    },
                                }),
                            );
                        }}
                    >
                        {Object.keys(brandings).map(option => (
                            <MenuItem value={option} primaryText={option} key={option} />
                        ))}
                    </SelectField>
                    <TextField
                        onBlur={e => {
                            this.notifyChanges(
                                update(theme, {
                                    defaultBranding: {
                                        $merge: { brandingPrimary: e.target.value },
                                    },
                                }),
                            );
                        }}
                        floatingLabelText="Textual primary branding"
                    />
                    <SelectField
                        floatingLabelText="Secondary branding logos"
                        value={theme.defaultBranding.brandingSecondary}
                        defaultValue={theme.defaultBranding.brandingSecondary}
                        onChange={(e, index, value) => {
                            this.notifyChanges(
                                update(theme, {
                                    defaultBranding: {
                                        $merge: { brandingSecondary: value },
                                    },
                                }),
                            );
                        }}
                    >
                        {Object.keys(brandings).map(option => (
                            <MenuItem value={option} primaryText={option} key={option} />
                        ))}
                    </SelectField>

                    <TextField
                        defaultValue={theme.defaultBranding.brandingSecondary}
                        onBlur={e => {
                            this.notifyChanges(
                                update(theme, {
                                    defaultBranding: {
                                        $merge: { brandingSecondary: e.target.value },
                                    },
                                }),
                            );
                        }}
                        floatingLabelText="Textual secondary branding"
                    />

                    {_.map(brandingOptions, (options, key) => (
                        <SelectField
                            key={key}
                            floatingLabelText={key}
                            value={_.get(brandingProps, key, _.get(brandingDefaultOptions, key))}
                            onChange={(event, index, value) => {
                                this.notifyChanges(
                                    update(theme, {
                                        brandingProps: {
                                            $merge: { [key]: value },
                                        },
                                    }),
                                );
                            }}
                        >
                            {options.map(option => <MenuItem value={option} primaryText={option} key={option} />)}
                        </SelectField>
                    ))}
                    <TextField
                        defaultValue={theme.brandingProps.height}
                        onBlur={e => {
                            this.notifyChanges(
                                update(theme, {
                                    brandingProps: {
                                        $merge: { height: e.target.value },
                                    },
                                }),
                            );
                        }}
                        floatingLabelText="Height"
                    />
                    <TextField
                        defaultValue={theme.brandingProps.width}
                        onBlur={e => {
                            this.notifyChanges(
                                update(theme, {
                                    brandingProps: {
                                        $merge: { width: e.target.value },
                                    },
                                }),
                            );
                        }}
                        floatingLabelText="Width"
                    />
                    <TextField
                        defaultValue={theme.brandingProps.padding}
                        onBlur={e => {
                            this.notifyChanges(
                                update(theme, {
                                    brandingProps: {
                                        $merge: { padding: e.target.value },
                                    },
                                }),
                            );
                        }}
                        floatingLabelText="Padding"
                    />
                </CardText>
            </Card>
        );
    };

    renderImagePickerField = (key, title) => {
        const { theme } = this.props;
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                    name={key + '_' + _.get(theme, key)}
                    defaultValue={_.get(theme, key)}
                    style={{ width: '100%' }}
                    onBlur={e => {
                        _.set(theme, key, e.target.value);
                        this.notifyChanges(theme);
                    }}
                />
                <FlatButton
                    icon={<IconImages />}
                    style={{ minWidth: '44px', marginLeft: 5 }}
                    onClick={() => {
                        this.setState({ imagePickerFor: key });
                    }}
                />
            </div>
        );
    };

    renderColorField = (key, title) => {
        const { theme } = this.props;
        return (
            <div key={key + '_' + _.get(theme, key)}>
                <TextField
                    className={cx({
                        'wdp-parent-value': this.isUsingParentValue(`${key}`),
                    })}
                    value={_.get(theme, key)}
                    onFocus={e => {
                        this.invokeColorPicker(key);
                    }}
                    floatingLabelText={title}
                />

                {this.resetIfWidgetMode(key)}

                {this.renderColorPicker(key, _.get(theme, key), val => {
                    _.set(theme, key, toRGBA(val.rgb));
                    this.notifyChanges(theme);
                })}
            </div>
        );
    };

    renderFontField = (key, title, stl) => {
        const { theme } = this.props;
        const { fontPopoverFor, fontPopoverForEl } = this.state;
        const font = theme.fonts[key];
        const popoverKey = `key_${key}`;

        return (
            <div key={key}>
                <div
                    style={{ height: 50, marginBottom: 10, display: 'flex' }}
                    className={cx({
                        'wdp-parent-value': this.isUsingParentValue(`fonts.${key}`),
                    })}
                >
                    <label style={{ width: '100%', padding: '16 0' }}>
                        {title}: {font.name}
                    </label>
                    <IconButton
                        iconStyle={{ width: 18, height: 18 }}
                        onClick={e => {
                            this.setState(
                                update(this.state, {
                                    $merge: {
                                        fontPopoverFor: popoverKey,
                                        fontPopoverForEl: e.target,
                                    },
                                }),
                            );
                        }}
                    >
                        <IconFont />
                    </IconButton>

                    {this.resetIfWidgetMode(`fonts.${key}`)}
                </div>

                <div style={{ ...font, ...stl, padding: 10 }}>
                    <span style={{ fontWeight: font.thin }}>
                        W{font.thin} {key} font is {font.gFontName}
                    </span>
                    <br />
                    <span style={{ fontWeight: font.normal }}>
                        W{font.normal} {key} font is {font.gFontName}
                    </span>
                    <br />
                    <span style={{ fontWeight: font.bold }}>
                        W{font.bold} {key} font is {font.gFontName}
                    </span>
                </div>

                <FontEditPoporver
                    open={popoverKey === fontPopoverFor}
                    font={font}
                    anchorEl={fontPopoverForEl}
                    onCloseRequest={() => {
                        this.setState({ fontPopoverFor: null });
                    }}
                    onChange={font => {
                        const u1 = update(theme, {
                            fonts: {
                                [key]: {
                                    $merge: font,
                                },
                            },
                        });
                        this.notifyChanges(u1);
                    }}
                />
            </div>
        );
    };

    renderFontSizeField = (title, path) => {
        const { theme } = this.props;
        const defaultValue = _.get(theme, path);

        return (
            <TextField
                type="number"
                name={`theme.${path}`}
                floatingLabelText={title}
                defaultValue={defaultValue}
                fullWidth
                onChange={(e, val) => {
                    this.notifyChanges(
                        update(theme, {
                            $merge: _.set(theme, path, isNaN(parseInt(val, 10)) ? defaultValue : parseInt(val, 10)),
                        }),
                    );
                }}
            />
        );
    };

    renderLayoutType = () => {
        const { widgetId, widget, widgetProps = {} } = this.props;

        if (!widgetId) return;

        const lll = widget.spec.propTypes.find(w => w.key === 'layoutType');
        if (!lll) return;

        return (
            <Card
                style={{ marginTop: '20px 0' }}
                initiallyExpanded={localStorage.getItem('LAYOUT_EXP') === 'true'}
                onExpandChange={exp => {
                    localStorage.setItem('LAYOUT_EXP', exp);
                }}
            >
                <CardHeader
                    className="template-editor__header"
                    title="Layout Type"
                    actAsExpander
                    showExpandableButton
                />
                <CardText expandable>
                    <SelectField
                        key="sd"
                        value={_.get(widgetProps, `layoutType`)}
                        onChange={(event, index, value) => {
                            if (this.props.onWidgetPropsChange) this.props.onWidgetPropsChange('layoutType', value);
                        }}
                    >
                        {lll.options.map(w => {
                            if (w.value === null) return; // do no allow to use inherit from theme
                            return <MenuItem value={w.value} primaryText={w.text} key={w.value} />;
                        })}
                    </SelectField>
                </CardText>
            </Card>
        );
    };

    renderColorPickerForCustomClass = () => {
        const { showColorPickerForCustomClass, customColors } = this.state;
        if (!showColorPickerForCustomClass) return null;
        const color = customColors[showColorPickerForCustomClass];

        return (
            <div style={{ position: 'fixed', zIndex: 2, right: 50, top: 215 }}>
                <SketchPicker
                    key="pi"
                    color={color}
                    onChangeComplete={picked => {
                        this.setState({
                            customColors: {
                                ...customColors,
                                [showColorPickerForCustomClass]: toRGBA(picked.rgb),
                            },
                        });
                        // const currentCustomColors = _.get(
                        //     this,
                        //     ['props', 'theme', 'widgetsColors', this.props.widgetId],
                        //     {}
                        // );
                        // if (currentCustomColors === null) {
                        //     customColors = {};
                        // }
                        // this.setState(
                        //     {
                        //         customColors: {
                        //             ...customColors,
                        //             [showColorPickerForCustomClass]: toRGBA(picked.rgb)
                        //         }
                        //     },

                        //     () => {
                        //         this.notifyChanges(
                        //             update(this.props.theme, {
                        //                 widgetsColors: {
                        //                     [this.props.widgetId]: {
                        //                         $set: {
                        //                             ...currentCustomColors,
                        //                             ...this.state.customColors
                        //                         }
                        //                     }
                        //                 }
                        //             })
                        //         );
                        //     }
                        // );

                        this.props.onCustomColorChange(this.props.widgetId, {
                            [showColorPickerForCustomClass]: toRGBA(picked.rgb),
                        });
                    }}
                />
            </div>
        );
    };

    renderDateFormatsStaff = () => {
        const dates = ['TIME', 'DATE_AND_TIME_SHORT', 'DATE_AND_TIME_FULL', 'DATE', 'DATE_SHORT'];

        const { theme } = this.props;

        return (
            <Card
                style={{ marginTop: '20px 0' }}
                initiallyExpanded={localStorage.getItem('DATE_EXP') === 'true'}
                onExpandChange={exp => {
                    localStorage.setItem('DATE_EXP', exp);
                }}
            >
                <CardHeader
                    className="template-editor__header"
                    title="Date formats"
                    actAsExpander
                    showExpandableButton
                />
                <CardText expandable>
                    {dates.map(d => (
                        <TextField
                            key={d}
                            defaultValue={_.get(this.props.theme, `dateFormats.${d}`)}
                            onBlur={e => {
                                this.notifyChanges(
                                    update(theme, {
                                        dateFormats: {
                                            $merge: { [d]: e.target.value },
                                        },
                                    }),
                                );
                            }}
                            floatingLabelText={d}
                        />
                    ))}
                </CardText>
            </Card>
        );
    };

    renderOtherStaff = () => {
        const { theme } = this.props;

        return (
            <Card
                style={{ marginTop: '20px 0' }}
                initiallyExpanded={localStorage.getItem('OTHER_EXP') === 'true'}
                onExpandChange={exp => {
                    localStorage.setItem('OTHER_EXP', exp);
                }}
            >
                <CardHeader
                    className="template-editor__header"
                    title="Other"
                    subtitle="Odds format"
                    actAsExpander
                    showExpandableButton
                />
                <CardText expandable>
                    <SelectField
                        key="top"
                        floatingLabelText="Odds format"
                        floatingLabelFixed
                        defaultValue={theme.oddsFormat}
                        value={theme.oddsFormat}
                        onChange={(event, index, value) => {
                            this.notifyChanges(
                                update(theme, {
                                    $merge: { oddsFormat: value },
                                }),
                            );
                        }}
                    >
                        {[{ val: 'decimal', key: 'Decimal' }, { val: 'fractional', key: 'Fractional' }].map(k => {
                            return <MenuItem value={k.val} primaryText={k.key} key={k.key} />;
                        })}
                    </SelectField>
                </CardText>
            </Card>
        );
    };

    render() {
        const { theme } = this.props;
        const { widgetId } = this.props;

        return (
            <div>
                {/* {!widgetId && this.renderSkin()} */}

                {this.renderColorPickerForCustomClass()}

                {this.renderLayoutType()}

                {this.renderFontStaff()}
                {this.renderMainColor()}
                {this.renderLayersControls()}

                {this.renderLayoutStaff()}
                {this.renderBrandingStaff()}

                {this.renderDisplayStaff()}

                {_.toPairs(colorsSets).map(pair => (
                    <Card
                        key={pair[0]}
                        style={{ marginTop: '0px' }}
                        initiallyExpanded={localStorage.getItem(`${pair[0]}_EXP`) === 'true'}
                        onExpandChange={exp => {
                            localStorage.setItem(`${pair[0]}_EXP`, exp);
                        }}
                    >
                        <CardHeader
                            className="template-editor__header"
                            title={`Colors for ${pair[0]}`}
                            actAsExpander
                            showExpandableButton
                        />
                        <CardText expandable>{pair[1].map(i => this.renderColorField(i, i))}</CardText>
                    </Card>
                ))}

                {this.renderDateFormatsStaff()}

                {this.renderOtherStaff()}

                {this.state.imagePickerFor && (
                    <ImageUploaderContainer
                        onCopy={url => {
                            _.set(theme, this.state.imagePickerFor, url);

                            this.notifyChanges(theme);

                            this.setState({
                                imagePickerFor: null,
                            });
                        }}
                        onClose={() => {
                            this.setState({
                                imagePickerFor: null,
                            });
                        }}
                        modal
                        galleryFirst
                        cdnOnly
                        cdnLabel="Pick"
                    />
                )}
            </div>
        );
    }
}

export default SplitImageTPLEditor;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/templates/SplitImageTPLEditor.js
 **/